// Prikazi obavijesti ajax formi
export default function showNotification(data)  {

    var msgModal = new Modal(document.getElementById('messageModal'), {
        keyboard: false
    });

    var modalTitle = document.querySelector('#messageModal h4');
    var modalBody = document.querySelector('#messageModal .modal-body div');
    var modalContent = document.querySelector('#messageModal .modal-content');

    modalTitle.innerHTML = '';
    modalBody.innerHTML = '';


    if (data.success) {

        if ('msg' in data) {
            modalTitle.innerHTML = data.msg;

            modalContent.setAttribute('class', 'modal-content alert-success');
            msgModal.show();
            setTimeout(function () {
                msgModal.hide();
            }, 5000);
        }
    }
    else {

        modalBody.innerHTML = '<ul></ul>';
        var modalList = document.querySelector('#messageModal .modal-body ul');

        if ('error' in data) {

            modalTitle.innerHTML = data.error;

            if ('errormsg' in data) {
                modalList.innerHTML += '<li><h4>'+data.errormsg+'</h4></li>';
            }

            modalContent.setAttribute('class', 'modal-content alert-danger');
            msgModal.show();
            setTimeout(function () {
                msgModal.hide();
            }, 5000);
        }
        else if ('errors' in data) {
            if(data.errormsg) modalTitle.innerHTML = data.errormsg;

            Object.entries(data.errors).forEach(entry => {
                const [index, error] = entry;
                modalList.innerHTML += '<li><h4>'+error+'</h4></li>';
            });


            modalContent.setAttribute('class', 'modal-content alert-danger');
            msgModal.show();
            setTimeout(function () {
                msgModal.hide();
            }, 5000);
        }

    }

}

window.clearForm = function(data,form) {

    form.querySelectorAll('input[type=text]').forEach(el => {
        el.value = '';
    });

    form.querySelectorAll('textarea').forEach(el => {
        el.value = '';
    });

}